import { encodeQueryData } from '../helpers/functions/encodeQueryData'
import { getUri } from '../helpers/functions/getUri'
import DataTypeModel from '../models/DataType'
import httpClient from './common'
import { AxiosResponse } from 'axios'

const get = <T>(requestParams, data = DataTypeModel(), cancelToken?: any): Promise<AxiosResponse<T>> =>
    httpClient.get<T>(getUri(requestParams.uri, data.uriParams) + encodeQueryData(data.bodyRequest), {
        ...requestParams.config,
        cancelToken,
    })
const post = <T>(requestParams, data = DataTypeModel(), cancelToken?: any): Promise<AxiosResponse<T>> =>
    httpClient.post<T>(getUri(requestParams.uri, data.uriParams), data.bodyRequest, {
        ...requestParams.config,
        cancelToken,
    })
const put = <T>(requestParams, data = DataTypeModel(), cancelToken?: any): Promise<AxiosResponse<T>> =>
    httpClient.put<T>(getUri(requestParams.uri, data.uriParams), data.bodyRequest, {
        ...requestParams.config,
        cancelToken,
    })
const destroy = <T>(requestParams, data = DataTypeModel(), cancelToken?: any): Promise<AxiosResponse<T>> =>
    httpClient.delete<T>(getUri(requestParams.uri, data.uriParams), { ...requestParams.config, cancelToken })

export { get, post, put, destroy }
